import { Provider } from '@angular/core';
import { selectInterfaceLanguage } from '@mkp/core/state';
import { selectGdprFunctional, selectGdprIsLoaded } from '@mkp/gdpr/state';
import { gdprModalActions } from '@mkp/gdpr/state/actions';
import { GdprModalService } from '@mkp/gdpr/ui';
import { selectIsBoUser } from '@mkp/user/state-logged-in/selectors';
import { INTERFACE_LANGUAGE, ZENDESK_HOST, ZendeskHost } from '@mkp/shared/util-zendesk';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export const provideZendeskHost = (): Provider[] => [
  {
    provide: ZENDESK_HOST,
    useFactory: (store: Store, gdprModalService: GdprModalService): ZendeskHost => ({
      consentLoaded$: store.select(selectGdprIsLoaded),
      functionalConsent$: store.select(selectGdprFunctional),
      // The selector throws rather than emitting while the user feature is unregistered.
      isBoUser$: store.select(selectIsBoUser).pipe(catchError(() => of(false))),
      requestFunctionalConsent: () =>
        gdprModalService
          .openGdprFunctionalDialog(gdprModalActions.setGdprFromZendeskPlaceholder)
          .pipe(map((gdpr) => !!gdpr?.functional)),
    }),
    deps: [Store, GdprModalService],
  },
  {
    provide: INTERFACE_LANGUAGE,
    useFactory: (store: Store) => store.selectSignal(selectInterfaceLanguage),
    deps: [Store],
  },
];
